import Component from '../../js/_Component';

const CNAME = 'c-page-recipe';

export default class PageRecipe extends Component {

	private baseScale: number;

	private recipeId: string;

	private scaleInput: HTMLInputElement;

	private ingredientsUnavailable = true;

	constructor(element: HTMLElement) {
		super(element);

		this.element.querySelector(`.${CNAME}--ingredient-button.m-recipe-scale`).addEventListener('click', () => this.scaleRecipe());
		this.element.querySelector(`.${CNAME}--ingredient-button.m-recipe-reset`).addEventListener('click', () => this.resetRecipeScale());
		this.element.querySelector(`.${CNAME}--ingredient-button.m-export-pdf`).addEventListener('click', () => this.downloadPdf());
		this.element.querySelector(`.${CNAME}--ingredient-button.m-export-excel`).addEventListener('click', () => this.downloadExcel());
// 		this.element.querySelector(`.${CNAME}--ingredient-button.m-costing`).addEventListener('click', () => this.downloadCosting());
		this.element.querySelector(`.${CNAME}--ingredient-button.m-analysis`).addEventListener('click', () => this.downloadAnalysis());
		this.scaleInput = this.element.querySelector(`.${CNAME}--ingredient-heading-controls input[name="standard-yield"]`);

		this.baseScale = parseInt(this.scaleInput.value);
		//this.recipeId = window.location.pathname.split('/').slice(-1)[0];

		this.recipeId = window.location.pathname.replace(/^\/(.+[^\/])\/?$/,'$1').split('/').slice(-1);

		this.scaleRecipe();
	}

	resetRecipeScale() {
		this.scaleInput.value = this.baseScale.toString();
		this.scaleRecipe();
	}

	scaleRecipe() {
		let scale = parseInt(this.scaleInput.value);
		if (!scale || scale <= 0) {
			return;
		}

		// Clear out content and show indicator again.
		this.element.querySelector(`.${CNAME}--ingredient`).innerHTML = '';
		this.element.classList.add('m-ingredients-loading');

		fetch(`/action-recipe-ingredients/?id=${this.recipeId}&servings=${scale}`)
			.then(results => {
				this.element.classList.remove('m-ingredients-loading');
				if (results.status == 200) {
					results.text().then(rawTable => {
						this.element.querySelector(`.${CNAME}--ingredient`).innerHTML = rawTable;
					});
					this.ingredientsUnavailable = false;
				} else {
					this.element.classList.add('m-ingredients-unavailable');
				}
			})
	}

	downloadPdf() {
		let scale = parseInt(this.scaleInput.value);
		if (this.ingredientsUnavailable || !scale || scale <= 0) {
			return;
		}

		window.open(`/action-recipe-export/?id=${this.recipeId}&servings=${scale}&format=PDF`,"_blank");
	}

	downloadExcel() {
		let scale = parseInt(this.scaleInput.value);
		if (this.ingredientsUnavailable || !scale || scale <= 0) {
			return;
		}

		window.open(`/action-recipe-export/?id=${this.recipeId}&servings=${scale}&format=Excel`,"_blank");
	}

	downloadCosting() {
		let scale = parseInt(this.scaleInput.value);
		if (this.ingredientsUnavailable || !scale || scale <= 0) {
			return;
		}

		window.open(`/action-recipe-report/?id=${this.recipeId}&servings=${scale}&type=Cost`,"_blank");
	}

	downloadAnalysis() {
		let scale = parseInt(this.scaleInput.value);
		if (this.ingredientsUnavailable || !scale || scale <= 0) {
			return;
		}

		window.open(`/action-recipe-report/?id=${this.recipeId}&servings=${scale}&type=Nutrition`,"_blank");
	}
}

Component.register(PageRecipe, 'PageRecipe');
